export enum SwipeCellSide {
  Left = "left",
  Right = "right",
}
